import { render, staticRenderFns } from "./CredentialsSettingsSectionHeader.vue?vue&type=template&id=70bc0b96&scoped=true&"
import script from "./CredentialsSettingsSectionHeader.vue?vue&type=script&lang=js&"
export * from "./CredentialsSettingsSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsSettingsSectionHeader.vue?vue&type=style&index=0&id=70bc0b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc0b96",
  null
  
)

export default component.exports